import * as React from 'react';

import type { DeliverableAttachment } from 'types';

import CloudinaryImage from 'components/CloudinaryImage';
import CrossButton from 'components/buttons/cross-button/CrossButton';
import MediaPreview from 'components/MediaPreview';

import { isValidAssetUrl } from 'utils/url';

import type { SyntheticEvent } from 'react';

type Props = {
  showFileName?: boolean,
  width?: number | null,
  height?: number | null,
  attachment: DeliverableAttachment,
  isImagePreviewEnabled?: boolean,
  useAssetDirectly?: boolean,
  onDeleteAttachment?: (a: DeliverableAttachment) => void
};

class DeliverableMediaAttachment extends React.PureComponent<Props> {
  handleDelete = (event: SyntheticEvent<HTMLElement>): void => {
    const { attachment, onDeleteAttachment } = this.props;

    if (onDeleteAttachment) {
      onDeleteAttachment(attachment);
    }

    event.preventDefault();
    event.stopPropagation();
  };

  renderPreview(): React.ReactNode | undefined | null {
    const { attachment } = this.props;

    return (
      <div className="deliverable-media-row__preview">
        <CloudinaryImage
          image={{ url: attachment.url }}
          width={300}
          height={800}
          preserveAspectRatio
        />
      </div>
    );
  }

  renderMedia(): React.ReactNode | undefined | null {
    const { attachment, width, height, useAssetDirectly, onDeleteAttachment } = this.props;
    const previewWidth = width || 85;
    const previewHeight = height || 85;

    return (
      <React.Fragment>
        <MediaPreview
          className="deliverable-media-row__media"
          attachment={{ ...attachment, format: attachment.mediaType || attachment.assetType }}
          width={previewWidth}
          height={previewHeight}
          useAssetDirectly={useAssetDirectly}
        />
        {
          onDeleteAttachment && (
            <div className="deliverable-media-row__attachment-cross">
              <CrossButton
                type="corner-closer"
                onClick={this.handleDelete}
              />
            </div>
          )
        }
      </React.Fragment>
    );
  }

  render(): React.ReactNode {
    const { attachment, showFileName, width, isImagePreviewEnabled } = this.props;
    const isEnablePreview = isImagePreviewEnabled && isValidAssetUrl(attachment.url) && attachment.assetType !== 'video';
    const previewWidth = width || 85;

    return (
      <div className="deliverable-media-row__attachment">
        <div
          className="deliverable-media-row__attachment-preview"
          data-qa="deliverable-media-row__attachment-preview"
        >
          {
            isEnablePreview ?
              <div className="deliverable-media-row__media-wrapper">
                { this.renderMedia() }
                { this.renderPreview() }
              </div> :
              this.renderMedia()
          }
        </div>
        {
          showFileName && attachment.fileName &&
            <div
              className="deliverable-media-row__attachment-name text-overflow-ellipsis"
              title={attachment.fileName}
              style={{ width: `${previewWidth}px` }}
            >
              {attachment.fileName}
            </div>
        }
      </div>
    );
  }
}

export default DeliverableMediaAttachment;
